export const colors = {
  white: '#FFFFFF',
  whiteTransparent: 'rgba(255,255,255,0.5)',
  black: '#000000',
  primary: '#082E51',
  secondary: '#E5E5E5',
  tertiary: '#EF4B3D',
  grayTransparent: 'rgba(238,238,238,0)',
  gray: {
    50: '#eeeeee',
    100: '#d6d6d6',
    200: '#bebebe',
    300: '#a7a7a7',
    400: '#8f8f8f',
    500: '#777777',
    600: '#5f5f5f',
    700: '#474747',
    800: '#303030',
    900: '#181818',
  },
  blue: {
    50: '#9dc1fb',
    100: '#89b4fa',
    200: '#76a8f9',
    300: '#629bf8',
    400: '#4f8ff7',
    500: '#3B82F6',
    600: '#3575dd',
    700: '#2f68c5',
    800: '#295bac',
    900: '#234e94',
  },
  red: {
    50: '#f5938b',
    100: '#f48177',
    200: '#f26f64',
    300: '#f15d50',
    400: '#ef4b3d',
    500: '#d74437',
    600: '#bf3c31',
    700: '#a7352b',
    800: '#8f2d25',
    900: '#78261f',
  },
  green: {
    50: '#70d5b3',
    100: '#58cea7',
    200: '#40c79a',
    300: '#28c08e',
    400: '#10b981',
    500: '#0ea774',
    600: '#0d9467',
    700: '#0b825a',
    800: '#0a6f4d',
    900: '#085d41',
  },
  yellow: {
    50: '#facf85',
    100: '#f9c56d',
    200: '#f8bb54',
    300: '#f7b13c',
    400: '#f6a823',
    500: '#f59e0b',
    600: '#dd8e0a',
    700: '#c47e09',
    800: '#ac6f08',
    900: '#935f07',
  },
  purple: {
    50: '#c5aefb',
    100: '#b99dfa',
    200: '#ae8df9',
    300: '#a27df8',
    400: '#976cf7',
    500: '#8b5cf6',
    600: '#7d53dd',
    700: '#6f4ac5',
    800: '#6140ac',
    900: '#533794',
  },
}
